import React from "react";
import LinearProgress from "@material-ui/core/LinearProgress";
import Typography from "@material-ui/core/Typography";
import { i18n } from "../../translate/i18n";

/**
 * Barra "Mesclando X/Y" na linha do contato que fica (#4408). Contato sem
 * mensagens (total 0) mostra barra indeterminada até o evento de término.
 */
const MergeProgress = ({ progress }) => {
  if (!progress) return null;
  const { moved = 0, total = 0 } = progress;
  const determinate = total > 0;
  return (
    <div style={{ marginTop: 4, maxWidth: 260 }}>
      <LinearProgress
        variant={determinate ? "determinate" : "indeterminate"}
        value={determinate ? Math.min(100, Math.round((moved / total) * 100)) : undefined}
      />
      <Typography variant="caption" color="textSecondary">
        {i18n.t("contacts.mergeProgress", { moved, total })}
      </Typography>
    </div>
  );
};

export default MergeProgress;
